module.exports = __webpack_public_path__ + "password.3316297686a1eb638a02.ttf";


//////////////////
// WEBPACK FOOTER
// E:/code/onedoorcloses/public_html/pricing/src/assets/fonts/password.ttf
// module id = ../../../../../src/assets/fonts/password.ttf
// module chunks = styles